<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ "RELEASENOTES.HEADER" | translate}} - {{ "RELEASENOTES.COMP" | translate }}</mat-card-title>
        </mat-card-title-group>

        <mat-card-content>
            <div class="home-card" id="content">
                <div>
                    <ng-container *ngIf="error">
                        {{ "RELEASENOTES.ERROR_COMP_LIST" | translate }}
                    </ng-container>
                    <ng-container *ngIf="components.length >= 1">
                        <div class="toggle-btn-container">
                            <button mat-raised-button class="toggle-btn" (click)="toggleExpansion()">{{ this.allExpanded ? ("RELEASENOTES.COLLAPSE" | translate) : ("RELEASENOTES.EXPAND" | translate) }}</button>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let comp of components">
                        <button mat-stroked-button class="line-btn" (click)="toggleBtn(components.indexOf(comp), comp.componentName)">
                            {{ comp.componentName }}
                            <mat-icon iconPositionEnd>{{
                                this.expandedArray[components.indexOf(comp)] ? "expand_less" : "expand_more"
                            }}</mat-icon>
                        </button>
                        <div *ngIf="this.expandedArray[components.indexOf(comp)]" class="component">
                            <ng-container *ngIf="!comp.loaded">
                                <div class="loading">
                                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="comp.error">
                                {{ "RELEASENOTES.ERROR_COMP" | translate }}
                            </ng-container>
                            <ng-container *ngIf="comp.loaded && !comp.error">
                                <mat-accordion class="component" multi>
                                    <mat-expansion-panel *ngFor="let version of comp.component!.versions">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="title"> {{ version.versionTag }} </mat-panel-title>
                                            <mat-panel-description class="description">
                                                <p class="description-text">
                                                    {{ "RELEASENOTES.DATE" | translate }}:
                                                    {{ version.versionInfo.datetime | date : "dd.MM.yyyy" }}
                                                </p>
                                                <div *ngFor="let label of version.versionInfo.labels" class="label">
                                                    <mat-chip
                                                        [ngClass]="{
                                                            'security-label': label == 'security',
                                                            'bugfix-label': label == 'bugfix',
                                                            'feature-label': label == 'feature',
                                                            'improvement-label': label == 'improvement'
                                                        }"
                                                    >{{ label }}</mat-chip>
                                                </div>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-container>
                                            <div class="version">
                                                <ng-container *ngIf="comp.type == 'componentWithSubVersions'">
                                                    <div class="subversions-container">
                                                        <div class="subversions">
                                                            <ng-container *ngFor="let sub of version.subVersions">
                                                                <div class="subversions-version-container">
                                                                    <div class="subversions-version">
                                                                        <p>{{ sub.subVersionName }}:</p>
                                                                        <p>{{ sub.subVersionTag }}</p>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <div class="notes">
                                                    <div class="feature" *ngIf="version.versionNotes.features.length > 0">
                                                        <p class="header">{{ "RELEASENOTES.FEATURE" | translate }}</p>
                                                        <mat-list class="list">
                                                            <mat-list-item *ngFor="let item of version.versionNotes.features">
                                                                <div matLine>&bull; {{ item }}</div>
                                                            </mat-list-item>
                                                        </mat-list>
                                                    </div>
                                                    <div class="improvement" *ngIf="version.versionNotes.improvements.length > 0">
                                                        <p class="header">{{ "RELEASENOTES.IMPROVEMENT" | translate }}</p>
                                                        <mat-list class="list">
                                                            <mat-list-item *ngFor="let item of version.versionNotes.improvements">
                                                                <div matLine>&bull; {{ item }}</div>
                                                            </mat-list-item>
                                                        </mat-list>
                                                    </div>
                                                    <div class="bugfix" *ngIf="version.versionNotes.bugfixes.length > 0">
                                                        <p class="header">{{ "RELEASENOTES.BUGFIX" | translate }}</p>
                                                        <mat-list class="list">
                                                            <mat-list-item *ngFor="let item of version.versionNotes.bugfixes">
                                                                <div matLine>&bull; {{ item }}</div>
                                                            </mat-list-item>
                                                        </mat-list>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </mat-card-content>
    </div>
</mat-card>
